import React from 'react';
import PropTypes from 'prop-types';
import PageHeadingWrapper from 'components/PageHeadingWrapper';
import YourPaymentDetailsWidget from 'components/YourPaymentDetailsWidget';
import ViewLayout from 'views/ViewLayout';

const PaymentMethodView = ({
  changeUsageDisableReason,
  bacs,
}) => (
  <ViewLayout className="PaymentView">
    <PageHeadingWrapper>
      <h1>Payment Method</h1>
      <p>Manage your contact lens payment method</p>
    </PageHeadingWrapper>
    <YourPaymentDetailsWidget
      changeUsageDisableReason={changeUsageDisableReason}
      bacs={bacs}
    />
  </ViewLayout>
);

PaymentMethodView.displayName = 'PaymentMethodView';

PaymentMethodView.propTypes = {
  changeUsageDisableReason: PropTypes.node,
  bacs: PropTypes.object,
};

PaymentMethodView.defaultProps = {
  changeUsageDisableReason: null,
  bacs: null,
};

export default PaymentMethodView;
